import React, { useState, useEffect, useRef } from 'react'
import { DragDropProvider, sanitizeInitialChildren } from '@react-page/core/lib'

import { TextInput } from '@peracto/peracto-editor-ui'

import Item from './Item'

import * as S from './styled'

const Li = ({ plugin, insert, ...props }) => (
    <li {...props} data-testid={`${plugin.text.toLowerCase().replaceAll(' ', '-')}`}>
        <Item plugin={plugin} insert={insert} />
    </li>
)

const Inner = props => {
    const {
        editor: { plugins },
    } = props

    const [blockFilter, setBlockFilter] = useState('')
    const filterInput = useRef(null)

    useEffect(() => {
        filterInput.current.focus()
    }, [])

    const content = plugins.plugins.content
    const layout = plugins.plugins.layout
    const filterPlugins = plugins =>
        plugins.filter(plugin => {
            const hasText = plugin.text && plugin.text.length
            const filterQuery = hasText
                ? blockFilter.length > 0
                    ? plugin.text.toLowerCase().includes(blockFilter)
                    : true
                : false

            return hasText && filterQuery
        })

    return (
        <>
            <TextInput
                ref={filterInput}
                label="Filter Blocks"
                data-testid="filter-blocks"
                onChange={e => setBlockFilter(e.target.value.toLowerCase())}
            />

            <S.ContentBlockList>
                {filterPlugins(layout).map((plugin, k) => (
                    <Li
                        key={k}
                        plugin={plugin}
                        insert={{
                            ...sanitizeInitialChildren(plugin.createInitialChildren()),
                            layout: {
                                plugin,
                                state: plugin.createInitialState(),
                            },
                        }}
                    />
                ))}

                {filterPlugins(content).map((plugin, k) => (
                    <Li
                        key={k}
                        plugin={plugin}
                        insert={{
                            content: {
                                plugin,
                                state: plugin.createInitialState(),
                            },
                        }}
                    />
                ))}
            </S.ContentBlockList>
        </>
    )
}

const ContentBlockList = props => (
    <DragDropProvider>
        <Inner {...props} />
    </DragDropProvider>
)

export default ContentBlockList
